module.exports = "<p>\r\n  gastos-subcategoria works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/gastos/gastos-subcategoria/gastos-subcategoria.component.html
// module id = ./src/app/gastos/gastos-subcategoria/gastos-subcategoria.component.html
// module chunks = main